import React from 'react'
import Feature from './Feature'
import { FormattedMessage } from 'react-intl'
import { checkJapanese } from '../../../lib'

const PlanFeatures = (props) => (
  <div className='pl4'>
    <Feature
      tooltip={(checkJapanese()) ? `
          ブラウザですぐに使えます。ネイティブアプリのようにインストールする必要はありません。
        ` : `
          ブラウザですぐに使えます。ネイティブアプリのようにインストールする必要はありません。
        `}
      feature={(props.plan === 'free') ? (
        'インストールレス'
      ) : (
        'インストールレス'
      )}/>
    <Feature
      tooltip={(checkJapanese()) ? `
          同時に会議に参加できる人数です。
        ` : `
          同時に会議に参加できる人数です。
        `}
      feature={(props.plan === 'free') ? (
        '最大6人参加可能'
      ) : (
        '最大12人参加可能'
      )}/>
    <Feature
      tooltip={(checkJapanese()) ? `
          所有できる部屋の数です。所有した部屋でプレミアムの機能が使えます。
        ` : `
          所有できる部屋の数です。所有した部屋でプレミアムの機能が使えます。
        `}
      feature={(props.plan === 'free') ? (
        '0部屋'
      ) : (
        '5部屋'
      )}/>
    <Feature
      tooltip={(checkJapanese()) ? `
          会議可能な時間の長さです。
        ` : `
          会議可能な時間の長さです。
        `}
      feature={(props.plan === 'free') ? (
        '40分の会議'
      ) : (
        '時間無制限の会議'
      )}/>

    <Feature
      tooltip={(checkJapanese()) ? `
         自映像とスクリーンシェアの同時配信が可能です。また、新しくスクリーンシェアされた場合に、自動的に拡大します。
        ` : `
         自映像とスクリーンシェアの同時配信が可能です。また、新しくスクリーンシェアされた場合に、自動的に拡大します。
        `}
      feature={'高機能なスクリーンシェア'}/>
    {(props.plan !== 'free') ? (
      <div>
        <Feature
          tooltip={(checkJapanese()) ? `
              参加者や使用状況によって配信形式を変更します。現在サポートしているのはP2PかSFU。
            ` : `
              参加者や使用状況によって配信形式を変更します。現在サポートしているのはP2PかSFU。
            `}
          feature={'高品質な映像/音声配信'}/>
        <Feature
          tooltip={(checkJapanese()) ? `
              営業時間中( 9:00 ~ 17:00 ) にEmailによる使い方やご不明な点などのサポートを行います。webinar@anets.co.jp
            ` : `
              We support users by email if you need help
            `}
          feature={<FormattedMessage id='planFeatures.feature8'/>}/>
      </div>
    ) : ''}
  </div>
)

export default PlanFeatures



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/Plans/PlanFeatures.js